module.exports = __webpack_public_path__ + "img/icon-refund-to-bonus.c96fa13b.svg";